import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import Hero from './components/Hero';
import Services from './components/Services';
import CaseStudies from './components/CaseStudies';
import About from './components/About';
import Consultancy from './components/Consultancy';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Navigation from './components/Navigation';
import FAQ from './components/FAQ';
import Blog from './components/Blog';
import BlogAdmin from './pages/BlogAdmin';
import BlogPost from './pages/BlogPost';
import FeatureDetail from './pages/FeatureDetail';
import NavigatorPage from './pages/NavigatorPage';
import CaseStudyDetail from './pages/CaseStudyDetail';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import BibliaOrtodoxaPrivacy from './pages/BibliaOrtodoxaPrivacy';
import ScrollToAnchor from './components/ScrollToAnchor';

function HomePage({ scrolled }) {
  return (
    <>
      <Navigation scrolled={scrolled} />
      <Hero />
      <Services />
      <CaseStudies />
      <About />
      <Consultancy />
      <FAQ />
      <Contact />
      <Footer />
    </>
  );
}


function App() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <ThemeProvider>
      <Router>
        <ScrollToAnchor />
        <div className="min-h-screen bg-primary transition-colors duration-300 relative">
          {/* Subtle animated noise overlay */}
          <div className="fixed inset-0 pointer-events-none z-0"
            style={{ background: 'radial-gradient(ellipse at 50% 0%, rgba(0,212,255,0.05) 0%, transparent 60%)' }} />

          <div className="relative z-10">
            <Routes>
              <Route path="/" element={<HomePage scrolled={scrolled} />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/admin" element={<BlogAdmin />} />
              <Route path="/feature/:featureId" element={<FeatureDetail />} />
              <Route path="/navigator" element={<NavigatorPage />} />
              <Route path="/case-study/:id" element={<CaseStudyDetail />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/terms" element={<TermsOfService />} />
              <Route path="/bibliaortodoxa/privacy" element={<BibliaOrtodoxaPrivacy />} />
            </Routes>
          </div>
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
